"use client";

import { Sparkles } from "lucide-react";
import Image from "next/image";

const outputs = [
  "Product to model",
  "Image Variations",
  "Image creation",
  "Model swap",
  "E-commerce Studio",
  "AI Image Editor",
  "Face swap",
];

const CopyConverts = () => {
  return (
    <section className="bg-white px-5 pt-16 sm:px-6 sm:py-20 lg:px-10 md:pt-24">
      <div className="mx-auto grid w-full max-w-full grid-cols-1 items-center justify-items-center lg:gap-10 lg:grid-cols-2">
        {/* Visual */}
        <div className="flex justify-center order-2 lg:order-1">
          <Image
            src="/assets/adCreation/second-section.svg"
            width={600}
            height={600}
            alt="copy-converts"
            // className="w-full max-w-[700px]"
          />
        </div>

        {/* Copy */}
        <div className="text-center lg:text-left order-1 lg:order-2 ">
          <h2 className="solution-sub-heading mx-auto max-w-[600px] 2xl:max-w-[700px] 3xl:max-w-[800px] lg:mx-0">
            More variations. Less manual work.{" "}
            <span className="text-[#1F1FCA]">Better results.</span>
          </h2>

          <p className="mt-4 mx-auto max-w-[400px] 2xl:max-w-[500px] 3xl:max-w-[600px] body-secondary-text lg:mx-0">
            Generate, test, and optimize dozens of creatives in minutes, so your
            team spends less time making ads and more time scaling what works.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CopyConverts;
